import * as Yup from "yup";

export const companyInformationSchema = Yup.object({
    companyname: Yup.string().trim().required("Company name is required"),
    address1:Yup.string().trim().required("Address1 is required"),
    zipcode: Yup.string().trim().required("Zipcode is required"),
    city:Yup.string().trim().required("City is required"),
    country:Yup.string().trim().required("Country is required"),
    industry:Yup.string().trim().required("Industry is required"),
    phonenumber:Yup.string().trim().required("Phone number is required").min(10,"Min 10 numbers required").max(10,"Max 10 numbers are required"),
    accountpayablename:Yup.string().trim().required("Accounts Payable Contact Name is required"),
    accountpayableemail:Yup.string().trim().matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,"valid email").required("Accounts Payable Email is required"),
    accountpayablephone:Yup.string().trim().required("Accounts Payable Phone is required").min(10,"Min 10 numbers required").max(10,"Max 10 numbers are required")
});

export const editPOSchema = Yup.object({
    editPoName:Yup.string().trim().required("Company name is required"),
    editPoValue:Yup.number().required("Company name is required").min(1,"Minimum value should be greater than 0")
});

export const textFieldValidation = Yup.object({
    name:Yup.string().trim().required("Name is required").matches(/^[a-z\d\-_\s]+$/i,"Please enter valid name").min(3,"Name must be 3 characters long.")
});

export const resetPasswordSchema = Yup.object({
    password: Yup.string().required("Password is required.")
        .min(8,'You need at least 8 characters.')
        .matches(/[0-9]/, 'You need at least 1 number.')
        .matches(/[a-zA-Z]/, 'You need at least 1 character.'),
    confirmPassword: Yup.string().required("Confirm password is required.")
        .oneOf([Yup.ref('password')], "The passwords don't match.")
  });


export const newUserPasswordSchema = resetPasswordSchema.clone().shape({
    currentPassword: Yup.string().required("Current password is required."),
  });
